import { useNavigate } from "react-router-dom";
import Button from '@mui/material/Button';

type Props = {
  redirect: string
}

export default function CancelButton(props: Props) {

  let navigate = useNavigate();
  const routeChange = () =>{
    navigate(props.redirect, { replace: true });
  }

  return (
    <Button className="login primary text" size="small" onClick={routeChange}>Cancelar</Button>
  );
}